import { useState, useEffect } from "react";
import { api } from "../api";
import GameCard from "../components/GameCard";
import { GameCardSkeleton, CategoryChipSkeleton } from "../components/Skeleton";

const categoryIcons = {
  "Action RPG": (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L2 7l10 5 10-5-10-5z" /><path d="M2 17l10 5 10-5" /><path d="M2 12l10 5 10-5" />
    </svg>
  ),
  Platformer: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="2" y="6" width="20" height="12" rx="2" /><path d="M12 12h.01" /><path d="M6 12h.01" /><path d="M18 12h.01" />
    </svg>
  ),
  Racing: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="7" cy="17" r="2" /><circle cx="17" cy="17" r="2" /><path d="M5 17h-2v-4l2-5h9l4 5h1a2 2 0 012 2v2h-2" /><path d="M19 10l-3-4" />
    </svg>
  ),
  Puzzle: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M19.439 7.85c-.049.455.063 1.003.505 1.5" /><path d="M19.439 7.85A2.5 2.5 0 0017.5 5h-2.5" /><path d="M19.439 7.85A2.5 2.5 0 0117.5 10h-2.5" /><path d="M12 5v-2a1 1 0 00-1-1h-2a1 1 0 00-1 1v2" /><rect x="3" y="5" width="14" height="14" rx="2" />
    </svg>
  ),
  Survival: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="M12 8v4" /><path d="M12 16h.01" />
    </svg>
  ),
  Simulation: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M2 22h20" /><path d="M6 22V12l4-4" /><path d="M10 22V8l4-4" /><path d="M14 22V4l4-4" /><path d="M18 22V2" />
    </svg>
  ),
  Strategy: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="3" /><path d="M12 2v7" /><path d="M12 15v7" /><path d="M2 12h7" /><path d="M15 12h7" />
    </svg>
  ),
  Adventure: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><path d="M2 12h20" /><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z" />
    </svg>
  ),
};

function Home() {
  const [games, setGames] = useState([]);
  const [categories, setCategories] = useState([]);
  const [activeCategory, setActiveCategory] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([api.get("/games"), api.get("/categories")]).then(([gamesData, catsData]) => {
      setGames(gamesData.data || gamesData);
      setCategories(catsData);
    }).finally(() => setLoading(false));
  }, []);

  const filtered = activeCategory
    ? games.filter((g) => g.category?.slug === activeCategory)
    : games;

  return (
    <div className="home">
      <header className="home-header">
        <h1>BongoGames</h1>
        <p>Pata games kali za simu na Computer yako</p>
      </header>

      <div className="category-strip">
        <button
          className={`category-chip ${activeCategory === null ? "active" : ""}`}
          onClick={() => setActiveCategory(null)}
        >
          <span className="chip-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
          </span>
          <span className="chip-label">All</span>
        </button>
        {categories.map((cat) => (
          <button
            key={cat.id}
            className={`category-chip ${activeCategory === cat.slug ? "active" : ""}`}
            onClick={() => setActiveCategory(cat.slug)}
          >
            <span className="chip-icon">{categoryIcons[cat.name] || categoryIcons[Object.keys(categoryIcons)[0]]}</span>
            <span className="chip-label">{cat.name}</span>
          </button>
        ))}
      </div>

      {loading ? (
        <>
          <div className="category-strip">
            <div className="category-chip active"><span className="chip-label">All</span></div>
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="category-chip"><CategoryChipSkeleton /></div>
            ))}
          </div>
          <div className="games-grid">
            {Array.from({ length: 6 }).map((_, i) => (
              <GameCardSkeleton key={i} />
            ))}
          </div>
        </>
      ) : (
        <div className="games-grid">
          {filtered.map((game) => (
            <GameCard key={game.id} game={game} />
          ))}
        </div>
      )}
    </div>
  );
}

export default Home;
